<footer class="content-footer footer bg-footer-theme">
    <div class="container-xxl">
        <div class="footer-container d-flex align-items-center justify-content-between py-4 flex-md-row flex-column">
            
            <!-- year -->
            @let year = (currentYear | localizedNumber) | async;

            <!-- copyright -->
            <div 
                class="footer-text"
                [innerHTML]="'SYSTEM_COMPONENTS.FOOTER.COPYRIGHT' | translate: { year }">
            </div>
            
        </div>
    </div>
</footer>